import * as React from "react";
import styled from "styled-components";

import Translate from "../../common/components/Translate";
import { PrimaryButton, LinkButton } from "../../common/components/buttons";

interface Props {
  selectedCount: number;
  onSubmit(): void;
  onCancel(): void;
}

class CompanyValuesSelectorActions extends React.PureComponent<Props> {
  public render() {
    const { selectedCount, onSubmit, onCancel } = this.props;
    const restCount = 6 - selectedCount;
    return (
      <Wrapper>
        {restCount > 0 && (
          <Counter>
            <Translate id="company.values.rest_count" values={{ count: restCount }} />
          </Counter>
        )}
        <CancelButton onClick={onCancel}>
          <Translate id="company.buttons.cancel" />
        </CancelButton>
        <PrimaryButton onClick={onSubmit}>
          <Translate id="company.buttons.complete" />
        </PrimaryButton>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 20px 20px;
`;

const CancelButton = LinkButton.extend`
  margin-right: 20px;
`;

const Counter = styled.div`
  margin-right: auto;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.56);
`;

export default CompanyValuesSelectorActions;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesSelectorActions.tsx